import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { isFunction, isEmpty } from 'lodash-es'

import { useAbsoluteUrl } from '../../hooks'

import './ImageComponent.scss'

const ImageComponent = (props) => {
  const { backup, type, src, onError, style, ...propsImg } = props

  const absoluteUrlSrc = useAbsoluteUrl(src)
  const [srcState, setSrcState] = useState(absoluteUrlSrc)
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    if (isEmpty(absoluteUrlSrc)) {
      setSrcState('')
      return undefined
    }

    const image = new Image()
    image.onload = () => setSrcState(absoluteUrlSrc)
    image.onerror = () => {
      setIsError(true)
      if (isFunction(onError)) {
        onError()
      }
    }
    image.src = absoluteUrlSrc

    return () => {
      image.onload = () => {}
      image.onerror = () => {}
    }
  }, [absoluteUrlSrc, onError])

  if (isError && React.isValidElement(backup)) {
    return backup
  }

  if (type === 'background-cover' || type === 'background-contain') {
    const { className } = props
    return (
      <div
        className={classnames('image-component', type, {
          [className]: className,
        })}
        style={{ ...props.style, backgroundImage: `url(${srcState})` }}
      />
    )
  }

  return <img alt="" {...propsImg} src={srcState} style={style} />
}

ImageComponent.propTypes = {
  backup: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  src: PropTypes.string,
  alt: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
  onError: PropTypes.func,
  loading: PropTypes.oneOf(['auto', 'lazy', 'eager']),
  type: PropTypes.oneOf(['image', 'background-cover', 'background-contain']),
  style: PropTypes.object,
}

ImageComponent.defaultProps = {
  type: 'image',
  loading: 'lazy',
}

export default ImageComponent
